import { Box } from "./box";

export class Announcer {
    backgroundUrl: string;
    gif: string;
    heading: string;
    subtitle: string;
    description: string;
    boxes: Box[] = [];
    constructor(url: string,
        gif: string,
        heading: string,
        subtitle: string,
        description: string,
        boxes = []) {
        this.backgroundUrl = url;
        this.gif = gif;
        this.heading = heading;
        this.subtitle = subtitle;
        this.description = description;
        this.boxes = boxes;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/announcer.model.ts